
export function getDurationFromString(durationString: string): number {

    const parts = durationString.split(':').map(Number);

    let hours = 0;
    let minutes = 0;
    let seconds = 0;
  
    if (parts.length === 3) {
      [hours, minutes, seconds] = parts;
    } else if (parts.length === 2) {
      [minutes, seconds] = parts;
    } else {
      throw new Error('Invalid duration format. Expected "HH:MM:SS" or "MM:SS".');
    }
  
    return hours * 3600 + minutes * 60 + seconds;
}

export function getDurationString(duration?: number): string {


    if (duration === undefined || duration === null) {
        return '';
    }

    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = duration % 60;
  
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}


export function getDistanceFromString(distanceString: string): number {
    return parseFloat(distanceString) * 5280;
}